import { useCallback, useEffect, useState } from "react";
import { FAVORITES_KEY, RECENTS_KEY, pushRecent, readStored, toggleFavorite, writeStored } from "../lib/apps";

// Favorite applications and recently opened pages, kept in this browser only (user's decision: no server storage).
export default function useNavMemory() {
  const [favorites, setFavorites] = useState(() => readStored(FAVORITES_KEY, []));
  const [recents, setRecents] = useState(() => readStored(RECENTS_KEY, []));

  const toggle = useCallback((id) => {
    setFavorites((current) => {
      const next = toggleFavorite(current, id);
      writeStored(FAVORITES_KEY, next);
      return next;
    });
  }, []);

  const remember = useCallback((id, at = Date.now()) => {
    setRecents((current) => {
      if (current[0]?.id === id) return current;
      const next = pushRecent(current, id, at);
      writeStored(RECENTS_KEY, next);
      return next;
    });
  }, []);

  // Another tab may have changed them.
  useEffect(() => {
    const sync = () => {
      setFavorites(readStored(FAVORITES_KEY, []));
      setRecents(readStored(RECENTS_KEY, []));
    };
    window.addEventListener("storage", sync);
    return () => window.removeEventListener("storage", sync);
  }, []);

  return { favorites, toggleFavorite: toggle, recents, remember };
}
